// Word.run rejects with OfficeExtension.Error, which is not a native Error subclass (see
// @types/office-js) — normalized to a real Error here so `err instanceof Error` checks
// upstream (chat.ts) keep working and surface the underlying message instead of falling
// back to a generic one.
async function runWord<T>(action: (context: Word.RequestContext) => Promise<T>): Promise<T> {
  try {
    return await Word.run(action);
  } catch (err) {
    const message = err instanceof Error ? err.message : (err as { message?: string })?.message;
    throw new Error(message || "Could not communicate with the document.");
  }
}

// True only inside Word's WebView2 host with office.js loaded — false in the standalone
// (non-Word) entry point, which never loads office.js at all. Guards the one runtime call site
// (chat.ts's DocumentSelectionChanged wiring) that would otherwise throw a ReferenceError in a
// plain browser tab.
export function isWordAvailable(): boolean {
  return typeof Office !== "undefined" && !!Office.context?.document;
}

export function getSelectedText(): Promise<string> {
  return runWord(async (context) => {
    const range = context.document.getSelection();
    range.load("text");
    await context.sync();
    return range.text;
  });
}
